import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { selectionFormData, selectedMemberCount, reloadRoster } from "../utils/roster_selection"

export default class extends Controller {
  static targets = ["modal", "title", "roleInput", "submitButton"]
  static values = { url: String }

  open(event) {
    event.preventDefault()

    const selectedCount = selectedMemberCount(this)
    if (selectedCount === 0) return

    this.resetForm()
    this.updateTitle(selectedCount)
    Modal.getOrCreateInstance(this.modalTarget).show()
    this.validate()
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    const roleSelected = this.roleInputTargets.some((input) => input.checked)
    this.submitButtonTarget.disabled = !roleSelected || this.submitButtonTarget.dataset.saving === "true"
  }

  async save(event) {
    event.preventDefault()

    const roles = this.selectedRoles()
    if (selectedMemberCount(this) === 0 || roles.length === 0 || !this.hasUrlValue) return

    this.setSaving(true)

    const formData = selectionFormData(this)
    formData.append("_method", "PATCH")
    roles.forEach((role) => formData.append("roles[]", role))

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      const data = await response.json()

      if (response.ok && data.success) {
        Modal.getOrCreateInstance(this.modalTarget).hide()
        reloadRoster(this)
      } else {
        const message = data?.errors?.join(", ") || `HTTP ${response.status}`
        alert(`Failed to update roles: ${message}`)
      }
    } catch (error) {
      console.error("Error bulk updating roles:", error)
      alert("An error occurred. Please try again.")
    } finally {
      this.setSaving(false)
      this.validate()
    }
  }

  modalHidden() {
    this.resetForm()
    this.validate()
  }

  resetForm() {
    this.roleInputTargets.forEach((input) => {
      input.checked = false
    })
  }

  updateTitle(count) {
    if (!this.hasTitleTarget) return

    const noun = count === 1 ? "member" : "members"
    this.titleTarget.textContent = `Edit role for ${count} ${noun}`
  }

  // Every role the selected members will hold (TMS-1880), replacing theirs.
  selectedRoles() {
    return this.roleInputTargets.filter((input) => input.checked).map((input) => input.value)
  }

  setSaving(saving) {
    if (!this.hasSubmitButtonTarget) return

    this.submitButtonTarget.dataset.saving = saving ? "true" : "false"
    this.submitButtonTarget.textContent = saving ? "Saving..." : "Save Changes"
    this.submitButtonTarget.disabled = saving || this.selectedRoles().length === 0
  }
}
